"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowDown = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
exports.ArrowDown = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("circle", { cx: "50%", cy: "50%", r: "13", fill: props.fill, stroke: "none" }),
    React.createElement("path", { d: "M 13 22 L 6 15", stroke: props.stroke, strokeWidth: props.strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M 13 22 L 20 15", stroke: props.stroke, strokeWidth: props.strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("line", { x1: "13", y1: "22", x2: "13", y2: "4", stroke: props.stroke, strokeWidth: props.strokeWidth, strokeLinecap: "round" }))); };
//# sourceMappingURL=arrowdown.js.map